import { createApp } from 'vue'
import CheckTable from '../components/checks/ChecksTable.vue';

if (document.getElementById('checks-table-container')) {
  const checksIndexVue = createApp({})
  checksIndexVue.component('CheckTable', CheckTable)
  checksIndexVue.mount('#checks-table-container')
}